module.exports = __webpack_public_path__ + "img/hero3.ebd7e52a.png";